import { useEffect } from 'react';
import {onSQFTLoadPrepareData, onSQFTLoadImport} from "../../helpers/sqftHelperUi";
import store from "../../../../store";

const useImportSQFTData = (visualizersLoaded) => {

  useEffect (() => {
    const state = store.getState()
    const {visualizerIsChanging} = state.serverState;
    if (visualizersLoaded.length && !visualizerIsChanging) {
      let payload = onSQFTLoadPrepareData();
      onSQFTLoadImport(payload);
    }

  }, [visualizersLoaded]);
};

export default useImportSQFTData;
